import { l10n } from 'i18n/i18nUtil';
import React from 'react';
import { RouteAccess } from 'vrlcm-gui-types';

export const BASE_ROUTE = `/lcm/cloud`;
export const MIGRATE_ROUTE = `/lcm/migrate`;
export const LCOPS_ROUTE = `/lcm/lcops`;
export const LOCKER = `/lcm/locker`;

export const ROUTES = {
  DASHBOARD: `${BASE_ROUTE}/dashboard`,
  CLOUD_PROXY: `${BASE_ROUTE}/cloud-proxy`,
  MIGRATE: `${BASE_ROUTE}/migrate`,
  ENVIRONMENTS: `${BASE_ROUTE}/environments`,
  CLOUD_INTEGRATIONS: `${BASE_ROUTE}/cloud-integrations`,
  CLOUD_UNIVERSAL_PRODUCTS: `${BASE_ROUTE}/cloud-universal-products`,
  REQUESTS: `${LCOPS_ROUTE}/requests`,
  PAGE_UNKNOWN: `${BASE_ROUTE}/page-unknown`
};

export const VERTICAL_NAV_ITEMS = {
  [ROUTES.DASHBOARD]: {
    title: l10n('cloud.dashboard'),
    icon: 'employee'
  },
  [ROUTES.CLOUD_PROXY]: {
    title: l10n('cloud.createCloudProxy'),
    icon: 'vm'
  },
  [ROUTES.ENVIRONMENTS]: {
    title: l10n('cloud.cloudProxies'),
    icon: 'cloud-network'
  },
  [ROUTES.CLOUD_INTEGRATIONS]: {
    title: l10n('cloud.cloudIntegrations'),
    icon: 'link'
  },
  [ROUTES.CLOUD_UNIVERSAL_PRODUCTS]: {
    title: l10n('cloud.cloudUniversal'),
    icon: 'license'
  }
};

export const getAuthorizedRoutes = (
  roles: string[],
  routeAccess: RouteAccess
) => {
  const routesAuthorities = Object.entries(routeAccess);

  const authorizedRoutes = routesAuthorities.reduce<
    typeof ROUTES_COMPONENT_MAP
  >((acc, [route, authorities]) => {
    if (
      (typeof authorities === 'string' && authorities === '*') ||
      (Array.isArray(authorities) &&
        authorities.some(a => roles.some(r => r === a)))
    ) {
      if (ROUTES_COMPONENT_MAP[route]) {
        acc[route] = ROUTES_COMPONENT_MAP[route];
      }
    }
    return acc;
  }, {});
  return authorizedRoutes;
};

const CloudAccount = React.lazy(() =>
  import('../components/cloud-account/CloudAccount')
);

const CloudIntegrations = React.lazy(() =>
  import('../components/cloud-integrations/CloudIntegrations')
);

const EnvironmentWorkflow = React.lazy(() =>
  import(
    '../../lcops/components/workflows/environment-workflow/EnvironmentWorkflow'
  )
);

const Environments = React.lazy(() =>
  import('../../lcops/components/environments/Environments')
);

const CloudUniversalProducts = React.lazy(() =>
  import('../components/cloud-universal/CloudUniversal')
);
const EnvironmentDetails = React.lazy(() =>
  import('../../lcops/components/environments/EnvironmentDetails')
);

export const DEFAULT_ROLE_ROUTES = {
  LOCKER_CERTIFICATE_ADMIN: ROUTES.DASHBOARD
};

export const ROUTES_COMPONENT_MAP = {
  [ROUTES.DASHBOARD]: CloudAccount,
  [ROUTES.MIGRATE]: CloudAccount,
  [ROUTES.CLOUD_INTEGRATIONS]: CloudIntegrations,
  [`${ROUTES.CLOUD_PROXY}/:requestId?`]: EnvironmentWorkflow,
  [`${ROUTES.ENVIRONMENTS}/:id`]: EnvironmentDetails,
  [ROUTES.ENVIRONMENTS]: Environments,
  [ROUTES.CLOUD_UNIVERSAL_PRODUCTS]: CloudUniversalProducts
};
